<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Marcas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="exportar" type="button" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <k-table
      :filterStatus="filterStatus"
      @crear="crear"
      :createButton="createButton"
      :editButton="false"
      :deleteButton="false"
      ref="listaMarcas"
      @seleccionar="seleccionar"
      :path="url + '/marcas/search'"
      :columns="[
            {
                display : 'Código',
                value : 'codigo'
            },
            {
                display : 'Nombre',
                value : 'nombre'
            },
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Fecha de creación',
                value : 'created_at'
            },
            {
                display : 'Fecha de modificación',
                value : 'updated_at'
            }
        ]"
    ></k-table>
    <modal :width="'80%'" height="auto" :scrollable="true" name="marca">
      <marca :searchButton="searchButton" @created="createdMarca"></marca>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    createButton: {
      type: Boolean,
      required: false,
      default: true
    },
    filterStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    searchButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      currentIndex: -1,
      url: url
    };
  },
  methods: {
    exportar: function() {
      let form = this.$refs.listaMarcas.form;
      window.open(
        url +
          "/marcas/search?exportar=S&status=" +
          form.status +
          "&search=" +
          form.search
      );
    },
    seleccionar: function(currentMarca) {
      this.$emit("selected", currentMarca);
    },
    crear: function() {
      this.$modal.show("marca");
    },
    createdCategoria: function(marca) {
      this.$refs.listaMarcas.actualizarLista(marca);
      this.$modal.hide("marca");
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/marcas/ListaMarcas.vue